import HomeView from '@/views/user/HomeView.vue';
import TeamLessView from '@/views/user/TeamLessView.vue';

export const userHomeRoutes = [
  {
    path: '/:tabName(info|submission|signup|select-criteria|submit-film)?',
    name: 'Home',
    component: HomeView,
    meta: { requiresAuth: true, section: 'Home' },
  },
  {
    path: '/teamless',
    name: 'TeamLess',
    component: TeamLessView,
    meta: { requiresAuth: true, section: 'TeamLess' },
  },
];
